import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { phoneAuthService } from '../services/phone-auth'
import { useAuthMode } from '../contexts/AuthModeContext'
import { getPhoneFromToken } from '../helpers/decodeJWT'

const ProtectedRoute = ({ children }) => {
  const history = useHistory()
  const { isSkipAuth } = useAuthMode()

  useEffect(() => {
    const phoneNumberFromToken = getPhoneFromToken()
    if (!phoneNumberFromToken) {
      phoneAuthService.clearAuth()
    }
  }, [])

  useEffect(() => {
    if (!isSkipAuth && !phoneAuthService.isAuthenticated()) {
      history.push('/registration')
    }
  }, [history, isSkipAuth])

  if (isSkipAuth || phoneAuthService.isAuthenticated()) {
    return children
  }

  return null
}

export default ProtectedRoute
